export { default } from './DetailedCarPreviewSpecification';
